import { render, staticRenderFns } from "./SubMenuBar.vue?vue&type=template&id=4d5d44ae&scoped=true&"
import script from "./SubMenuBar.vue?vue&type=script&lang=js&"
export * from "./SubMenuBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5d44ae",
  null
  
)

export default component.exports